<!-- VER TEMA FILTROS --> 
<template>
      <!-- BOTONES DE OPERACIONES EN CURSO -->
  <div class="offer-operations">
    <div v-if="!offerHasNegotiations && activeState" class="first-operation">
      <div v-if="offer.canOperate">
        <!-- FILTRO PARA QUE NO APAREZCAN LOS BOTONES Y MENSAJES DE NEGOCIABLES EN OFERTAS FINALIZADAS -->
        <div class="alert info message" v-if="!offerAction && this.filterType !== 'finishedNegotiations' && offer.state !== 'accept_pending'">
          <vs-icon icon="feedback"></vs-icon>
          Ha recibido una oferta de {{ $t(`offer.type.${offer.offerType}`) }},
          por favor seleccione la acción que desea tomar.
        </div>
        <!-- MENSAJE EN OFERTAS FINALIZADAS EN **** TAB NEGOCIACIONES **** CON ESTADO PUBLISHED O IN_NEGOTIATION -->
        <div v-if="this.filterType == 'finishedNegotiations'">
          <div class="alert info message" v-if="!offerAction">
            <vs-icon icon="feedback"></vs-icon>
            La oferta ha sido rechazada.
          </div>
        </div>
        <!-- BOTONES NEGOCIABLES -->
        <div
          v-if="offerAction === '' && offer.isParticipant && this.filterType !== 'finishedNegotiations' && offer.state !== 'accept_pending'"
          class="offer-actions"
        >
          <button
            data-test="button-acceptNegotiation"
            @click="offerAction = 'accept!'"
            class="btn btn-secondary btn--with-icon btn--inverted success"
          >
            <vs-icon icon="check"></vs-icon> Confirmar
          </button>
          <button
            data-test="button-deneidNegotiation"
            @click="offerAction = 'cancel!'"
            class="btn btn-secondary btn--with-icon btn--inverted danger"
          >
            <vs-icon icon="close"></vs-icon> Rechazar
          </button>
          <button
            data-test="button-reNegotiate"
            v-if="
              Object.values(offer.negotiableAttributes).includes(true) ||
                Object.values(
                  offer.negotiableAttributes.securePayment
                ).includes(true)
            "
            @click="offerAction = 'negotiate!'"
            class="btn btn-secondary btn--with-icon btn--inverted negotiate"
          >
            <vs-icon icon="compare_arrows"></vs-icon> Negociar
          </button>
        </div>
      </div>

      <!-- FILTRO PARA QUE APAREZCA OTRA INFO EN OFERTAS FINALIZADAS -->
      <div v-else-if="this.filterType == 'finishedNegotiations'">
        <div class="alert info message" v-if="!offerAction">
            <vs-icon icon="feedback"></vs-icon>
            La oferta ha sido rechazada.
          </div>
        </div>
    <!-- BOTON DE CANCELAR SIN NEGOCIACION (DESDE EL CREADOR DE LA OFERTA **** TAB MIS OFERTAS ****) -->
      <div v-else>
        <!-- CONDICIONAL QUE NO APAREZCA EN MIS OFERTAS FINALIZADAS Y NO APAREZCA CON ESTADO CONFIRMACION PENDIENTE-->
        <div v-if="this.filterType !== 'finishedOffers' && offer.state !== 'accept_pending'">
        <div class="alert info">
          <vs-icon icon="sync_disabled"></vs-icon>
          Su oferta todavía no ha recibido una respuesta.
        </div>
        <button
          v-if="!offerAction && offer.isParticipant"
          @click="offerAction = 'cancel!'"
          class="btn btn--inverted btn--with-icon danger"
        >
          <vs-icon icon="delete"></vs-icon> Cancelar oferta
        </button>
        </div>
        <!-- FEEDBACK AL USUARIO EN MIS OFERTAS FINALIZADAS -->
        <div v-else-if="this.filterType == 'finishedOffers'">
          <div class="alert info">
            <vs-icon icon="feedback"></vs-icon>
            La oferta ha sido rechazada.
          </div>
        </div>
      </div>
      <!-- BOTONES DE CONFIRMACION DE UNA ACCION SEA NEGOCIAR O CANCELAR -->
      <div
        v-if="offerAction && offerAction != 'negotiate!'"
        class="confirm-action"
      >
        <div class="message">
          ¿Está seguro que desea
          {{ $t(`offer.negotiations.${offerAction}`) }} la oferta?
        </div>
        <div class="negotiation-actions">
          <button
            data-test="button-cancelNegotiation"
            class="btn btn-secondary"
            type="flat"
            icon="close"
            @click="cleanActions"
          >
            Cancelar
          </button>
          <button
            data-test="button-confirmNegotiation"
            class="btn btn--inverted success"
            type="flat"
            icon="check"
            @click="offerFirstOperation"
          >
            Confirmar
          </button>
        </div>
      </div>
      <!-- /Confirm -->
    </div>
    <!-- /Without negotiation -->

    <!-- //////////////////// -->
    <!-- With negotiation/s -->
    <table
      data-test="tableInfoNegotations"
      class="n-table offer-negotiations"
      v-if="offerHasNegotiations && !showNegotiationForm"
    >
      <thead>
        <tr>
          <th>Estado</th>
          <th data-test="id-User">{{ participantsRol }}</th>
          <th>Negociación</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <NegotiationRow
          v-for="negotiation in negotiations"
          :ref="`negotiationRow${negotiation.id}`"
          :negotiation="negotiation"
          :offer="offer"
          :key="negotiation.id"
          :filterType="filterType"
          @negotiation-action="setNegotiationAction"
          @take-action="takeActionOnNegotiation"
          @in-negotiation="setInNegotiation"
        />
      </tbody>
    </table>

    <!-- /With negotiation/s -->

    <NegotiationForm
      ref="negotiationForm"
      v-if="showNegotiationForm"
      :offer="offer"
      :negotiation="inNegotiation"
      @clean-actions="cleanActions"
      @take-action="takeActionOnNegotiation"
      :negotiation-msg="negotiationMsg"
      @create-negotiation="startNegotiation"
    />

    <!-- Quantity error, can't accept negotiation -->
    <vs-popup
      title="Error en cantidad negociada"
      :active.sync="quantityErrorMsg"
      class="confirm-action"
    >
      <div class="alert danger">
        <vs-icon icon="warning"></vs-icon>
        <span
          >No puede aceptar la negociación ya que la cantidad disponible ({{
            offer.quantityLeft
          }}) es menor a la solicitada ({{
            quantityErrorNegotiation.quantity
          }}). Puede negociar cantidad o rechazar la negociación.</span
        >
      </div>
      <div class="footer">
        <button
          @click="negotiateQuantity(quantityErrorNegotiation.id)"
          class="btn negotiate"
        >
          Negociar cantidad
        </button>
        <button
          @click="
            quantityErrorMsg = false;
            quantityErrorNegotiation = {};
          "
        >
          Cerrar
        </button>
      </div>
    </vs-popup>
  <!-- APARECE POP UP DE AGRONACION ACEPTAR O RECHAZAR PARA CONFIRMAR DESPUES -->
    <vs-popup
      title="Pago Agro Nación"
      :active.sync="confirmPopup"
      :button-close-hidden="true"
      class="confirm-action agronacion"
    >
      <img
        alt="Logo Agronación"
        src="@/assets/images/logo_agronacion.png"
        class="logo-agronacion"
      />
      <div class="alert info">
        <vs-icon icon="warning"></vs-icon>
        <span>Está confirmando una operación con Pago Agro Nación.</span>
      </div>

      <div class="footer">
        <button @click="confirmPopup = false" class="btn cancel">
          Cancelar
        </button>
        <button
          class="btn confirm"
          @click="
            agreeWithANP = true;
            confirmPopup = false;
          "
        >
          Continuar
        </button>
      </div>
    </vs-popup>
      <!-- CONFIRMAR POP UP DE AGRONACION  -->
    <vs-popup
      title="Pago Agro Nación"
      :active.sync="confirmPopupNegotiation"
      :button-close-hidden="true"
      class="confirm-action agronacion"
    >
      <img
        alt="Logo Agronación"
        src="@/assets/images/logo_agronacion.png"
        class="logo-agronacion"
      />
      <div class="alert info">
        <vs-icon icon="warning"></vs-icon>
        <span>Está confirmando una operación con Pago Agro Nación.</span>
      </div>

      <div class="footer">
        <button @click="confirmPopupNegotiation = false" class="btn cancel">
          Cancelar
        </button>
        <button
          class="btn confirm"
          @click="
            agreeWithANPNegotiation = true;
            confirmPopupNegotiation = false;
          "
        >
          Continuar
        </button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import NegotiationRow from './NegotiationRow.vue'
import NegotiationForm from './NegotiationForm.vue'
import { mapState } from 'vuex'
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'

const transactionateOffer = gql`
  mutation transactionateOffer(
    $currentUserToken: String!
    $offerId: Int!
    $action: String!
  ) {
    transactionateOffer(
      currentUserToken: $currentUserToken
      offerId: $offerId
      action: $action
    ) {
      code
      message
      success
    }
  }
`

const createNegotiation = gql`
  mutation createNegotiation(
    $offerId: Int!
    $negotiableAttributes: NegotiationNegotiableAttributesInput!
    $offerorId: Int
    $senderId: Int
    $currentUserToken: String!
  ) {
    createNegotiation(
      offerId: $offerId
      negotiableAttributes: $negotiableAttributes
      offerorId: $offerorId
      senderId: $senderId
      currentUserToken: $currentUserToken
    ) {
      code
      message
      success
    }
  }
`

const transactionateNegotiation = gql`
  mutation transactionateNegotiation(
    $negotiationId: Int!
    $currentUserToken: String!
    $action: String!
    $negotiableAttributes: NegotiationNegotiableAttributesInput
    $originId: Int!
    $destinationId: Int!
  ) {
    transactionateNegotiation(
      negotiationId: $negotiationId
      currentUserToken: $currentUserToken
      action: $action
      negotiableAttributes: $negotiableAttributes
      originId: $originId
      destinationId: $destinationId
    ) {
      code
      message
      success
    }
  }
`

export default {
  name: 'offer-operations',
  components: {
    NegotiationRow,
    NegotiationForm
  },
  props: {
    offer: {
      type: Object,
      required: true
    },
    filterType: {
      type: String,
      required: false,
      default: 'activeOffers'
    },
    negotiations: {
      type: Array,
      required: false,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      offerAction: '',
      negotiationAction: '',
      inNegotiation: {},
      negotiationMsg: '',
      quantityErrorMsg: false,
      quantityErrorNegotiation: {},
      confirmPopup: false,
      agreeWithANP: false,
      confirmPopupNegotiation: false,
      agreeWithANPNegotiation: false,
      pendingNegotiation: {}
    }
  },

  watch: {
    agreeWithANP () {
      this.offerAction = 'accept!'
      this.takeActionOnOffer()
    },

    agreeWithANPNegotiation () {
      this.takeActionOnNegotiation(this.pendingNegotiation)
    }
  },

  computed: {
    ...mapState({
      currentUser: state => state.User.currentUser
    }),
    offerHasNegotiations () {
      return !!this.negotiations.length
    },
    activeState () {
      return ['published', 'pending', 'in_negotiation', 'accept_pending'].includes(
        this.offer.state
      ) // Include 'expired', see isuue #442
    },
    showNegotiationForm () {
      return (
        this.offerAction === 'negotiate!' ||
        this.negotiationAction === 'negotiate!'
      )
    },
    participantsRol () {
      var title = 'Vendedor'
      if (this.offer.offerType.split('_')[1] === 'sell') {
        title = 'Comprador'
      }
      return title
    }
  },
  methods: {
    negotiateQuantity (negId) {
      this.$refs[`negotiationRow${negId}`][0].$refs.negotiateBtn.click()
      this.quantityErrorMsg = false
      this.quantityErrorNegotiation = {}
    },
    localeDate (str) {
      return new Date(Date.parse(str) + 3.6e6 * 3).toLocaleDateString()
      // return (new Date(str)).toLocaleDateString()
    },
    setInNegotiation (neg) {
      this.inNegotiation = neg
    },
    offerFirstOperation () {
      if (this.offerAction === 'negotiate!') {
        this.startNegotiation()
      } else {
        this.takeActionOnOffer()
      }
    },
    cleanActions () {
      this.offerAction = ''
      this.negotiationAction = ''
      this.inNegotiation = {}
    },
    setNegotiationAction (action) {
      this.negotiationAction = action
    },
    negotiateAttr (attr) {
      if (this.negotiations.length > 1) {
        return
      }
      if (this.negotiations.length === 1) {
        if (this.negotiations[0].canOperate) {
          this.negotiationAction = 'negotiate!'
          this.$nextTick(() => this.$refs.negotiationForm.$refs[attr].focus())
        }
      } else if (this.offer.canOperate) {
        this.offerAction = 'negotiate!'
        this.$nextTick(() => this.$refs.negotiationForm.$refs[attr].focus())
      }
    },
    notify (action) {
      if (action != 'negotiate!') {
        var title = 'Oferta ' + this.$t(`offer.action.${action}`)
        var text =
          'La operación ha sido ' +
          this.$t(`offer.action.${action}`) +
          ' con éxito'
      } else {
        var title = 'Negociación enviada'
        var text = 'Su negociación ha sido enviada.'
      }
      this.$vs.notify({
        title: title,
        time: 8000,
        text: text,
        color: '#50b83d',
        position: 'top-right',
        icon: 'check_circle'
      })
    },
    canNegotiate (obj, attributes = {}) {
      let keys = Object.keys(attributes)
      let can = false
      keys.forEach(key => {
        if (key == 'securePayment') {
          if (!attributes.securePayment) {
            if (obj.securePayment) {
              can = true
            }
          } else {
            if (!obj.securePayment) {
              can = true
            } else {
              let qKeys = Object.keys(attributes[key])
              qKeys.forEach(qk => {
                let qVal = attributes[key][qk]
                if (qVal === false || !!qVal || qVal > 0) {
                  if (obj[key][qk] != qVal) {
                    can = true
                  }
                }
              })
            }
          }
        } else if (key === 'quality') {
          let qKeys = Object.keys(attributes[key])
          qKeys.forEach(qk => {
            let qVal = attributes[key][qk]
            if (qVal === false || !!qVal || qVal > 0) {
              if (obj[key][qk] != qVal) {
                can = true
              }
            }
          })
        } else {
          var val = attributes[key]
          if (val === false || !!val || val > 0) {
            if (obj[key] != val) {
              can = true
            }
          }
        }
      })
      return can
    },
    takeActionOnOffer () {
      if (this.offerAction == 'accept!') {
        if (this.offer.agroNacionPayment && !this.agreeWithANP) {
          this.confirmPopup = true
          return
        }
      }

      axios
        .post(`${process.env.VUE_APP_GRAPH_PATH}`, {
          query: print(transactionateOffer),
          variables: {
            currentUserToken: localStorage.getItem('USER_TOKEN'),
            offerId: this.offer.id,
            action: this.offerAction
          }
        })
        .then(res => {
          if (!res.data.errors) {
            if (res.data.data.transactionateOffer.success) {
              this.error = ''
              this.$emit('close-sidebar')
              this.notify(this.offerAction)
              this.cleanActions()
            } else {
              if (res.data.data.transactionateOffer.code == 'unauthorized') {
                this.$vs.notify({
                  title: 'No tiene permisos para realizar esta acción',
                  time: 3000,
                  // text: 'Por favor intente nuevamente',
                  color: '#DE3618',
                  position: 'top-right',
                  icon: 'error'
                })
              } else {
                console.log(res.data.data.transactionateOffer.code)
              }
            }
          }
        })
    },
    startNegotiation (attributes) {
      if (!this.canNegotiate(this.offer, attributes)) {
        this.negotiationMsg = 'not_have_changes'
        return false
      }

      this.negotiationMsg = ''
      axios
        .post(`${process.env.VUE_APP_GRAPH_PATH}`, {
          query: print(createNegotiation),
          variables: {
            offerId: this.offer.id,
            negotiableAttributes: attributes,
            currentUserToken: localStorage.getItem('USER_TOKEN')
          }
        })
        .then(res => {
          if (!res.data.errors) {
            if (res.data.data.createNegotiation.success) {
              this.$emit('close-sidebar')
              this.$vs.notify({
                title: 'Negociación enviada',
                time: 8000,
                text: 'Su negociación ha sido enviada',
                color: '#50b83d',
                position: 'top-right',
                icon: 'check_circle'
              })
              this.cleanActions()
            } else {
              if (res.data.data.createNegotiation.code == 'unauthorized') {
                this.$vs.notify({
                  title: 'No tiene permisos para realizar esta acción',
                  time: 3000,
                  // text: 'Por favor intente nuevamente',
                  color: '#DE3618',
                  position: 'top-right',
                  icon: 'error'
                })
              } else {
                console.log(res.data.data.createNegotiation.code)
              }
            }
          }
        })
    },
    takeActionOnNegotiation (neg, attributes = {}) {
      if (this.negotiationAction == 'accept!') {
        if (this.offer.agroNacionPayment && !this.agreeWithANPNegotiation) {
          this.pendingNegotiation = neg
          this.confirmPopupNegotiation = true
          return
        }
      }

      var negotiationChanges = {}
      if (this.negotiationAction === 'negotiate!') {
        if (!this.canNegotiate(neg, attributes)) {
          this.negotiationMsg = 'not_have_changes'
          return false
        }
        this.negotiationMsg = ''
        negotiationChanges = { negotiableAttributes: attributes }
      }

      axios
        .post(`${process.env.VUE_APP_GRAPH_PATH}`, {
          query: print(transactionateNegotiation),
          variables: Object.assign(
            {
              negotiationId: neg.id,
              originId: neg.origin.id,
              destinationId: neg.destination.id,
              currentUserToken: localStorage.getItem('USER_TOKEN'),
              action: this.negotiationAction
            },
            negotiationChanges
          )
        })
        .then(res => {
          this.pendingNegotiation = {}
          if (!res.data.errors) {
            if (res.data.data.transactionateNegotiation.success) {
              this.$emit('close-sidebar')
              this.notify(this.negotiationAction)
              this.cleanActions()
            } else {
              if (
                res.data.data.transactionateNegotiation.code == 'unauthorized'
              ) {
                this.$vs.notify({
                  title: 'No tiene permisos para realizar esta acción',
                  time: 3000,
                  // text: 'Por favor intente nuevamente',
                  color: '#DE3618',
                  position: 'top-right',
                  icon: 'error'
                })
              } else if (
                res.data.data.transactionateNegotiation.code ==
                'invalid_quantity'
              ) {
                this.quantityErrorMsg = true
                this.quantityErrorNegotiation = neg
              } else {
                console.log(res.data.data.transactionateNegotiation.code)
              }
            }
          }
        })
    }
  }
}
</script>
